import useSWRImmutable from "swr/immutable";
import authAxios from "../../helpers/authAxios";

export const getReportLogs = (url: string): Promise<any> =>
  authAxios.get(url).then((resp) => resp?.data?.result);

export const useReportLogs = (userId: string | undefined) => {
  const { data, error } = useSWRImmutable(
    `/reports/logs?userId=${userId}`,
    getReportLogs
  );
  return {
    reportLogs: data,
    isReportLogsLoading: !error && !data,
    isError: error,
  };
};
